import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { staffApi, errMsg } from "./api";
import { Field, Status } from "./Shell";
import { RecoveryCodes } from "./RecoveryCodes";

export const SecurityPanel = ({ user, onChange }) => {
  const [form, setForm] = useState({ password: "", code: "" });
  const [status, setStatus] = useState({});
  const [codes, setCodes] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading" });
    try {
      const { data } = await staffApi.post("/auth/recovery-codes", form);
      setCodes(Array.isArray(data?.recovery_codes) ? data.recovery_codes : []);
      setForm({ password: "", code: "" });
      setStatus({});
    } catch (err) {
      setStatus({ state: "error", msg: await errMsg(err) });
    }
  };

  if (codes) return <div className="max-w-xl"><RecoveryCodes codes={codes} onDone={() => { setCodes(null); onChange(); }} doneLabel="Done" /></div>;
  return (
    <div className="max-w-xl" data-testid="staff-security-panel">
      <p className="text-sm text-ink">Two-step sign-in is <strong>on</strong> for your account.</p>
      <p className="mt-1 text-sm text-slate" data-testid="staff-recovery-left">Recovery codes left: {user?.recovery_left ?? 0} of 10</p>
      <form onSubmit={submit} className="mt-8 space-y-5 border border-mist bg-white p-6" data-testid="staff-regenerate-form">
        <p className="font-semibold text-navy">Make new recovery codes</p>
        <p className="text-sm text-slate">This replaces all your old codes. Confirm with your password and a current code from your authenticator app.</p>
        <Field label="Password" type="password" required autoComplete="current-password" value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="staff-regenerate-password-input" />
        <Field label="Authenticator code" required inputMode="numeric" maxLength={6} autoComplete="one-time-code" value={form.code}
          onChange={(e) => setForm({ ...form, code: e.target.value })} data-testid="staff-regenerate-code-input" />
        <Status status={status} testId="staff-regenerate-status" />
        <button type="submit" disabled={status.state === "loading"} className="btn btn-navy disabled:opacity-60" data-testid="staff-regenerate-submit-button">
          {status.state === "loading" ? <Loader2 size={16} className="animate-spin" /> : <KeyRound size={16} />} Make New Codes
        </button>
      </form>
      <p className="mt-6 text-sm text-slate">Lost your phone and your codes? Ask the Administrator to reset your two-step sign-in.</p>
    </div>
  );
};
